import { render, staticRenderFns } from "./FormularioPosVendas.vue?vue&type=template&id=0a0a642f&"
import script from "./FormularioPosVendas.vue?vue&type=script&lang=js&"
export * from "./FormularioPosVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports